import React, { useContext } from "react";

import { Album } from "../types";
import SelfieSearchPreferenceCta from "./SelfieSearchPreferenceCta";
import SubscriptionCta from "./SubscriptionCta";
import { PhotoGridContext } from "../PhotoGrid";
import GroupedUploaderActions from "./GroupedUploaderActions";

interface UploaderButtonsProps {
  selectedEventId: number;
  selectedAlbum: Album | null;
  setShowUploaderOption: React.Dispatch<React.SetStateAction<boolean>>;
  showUploaderOption: boolean;
  setShowSelfieSearchPreferencePopup: React.Dispatch<
    React.SetStateAction<boolean>
  > | null;
  source: "breadcrumb" | "photogrid";
  setShowSubscriptionPopup: React.Dispatch<
    React.SetStateAction<boolean>
  > | null;
}

// this component will have all actions involved in upload photos flow
const UploadActions: React.FC<UploaderButtonsProps> = ({
  selectedEventId,
  setShowUploaderOption,
  showUploaderOption,
  selectedAlbum,
  setShowSelfieSearchPreferencePopup,
  source,
  setShowSubscriptionPopup
}) => {
  const photogridContext = useContext(PhotoGridContext);

  // Render selfie search preference CTA if the user needs to set preferences
  if (photogridContext?.shouldSetSelfieSearchPreference) {
    return (
      <SelfieSearchPreferenceCta
        setShowSelfieSearchPreferencePopup={setShowSelfieSearchPreferencePopup}
        source={source}
        selectedEventId={selectedEventId}
        selectedAlbum={selectedAlbum}
      />
    );
  }
  // Render subscription CTA if the user needs to subscribe to a free event
  if (photogridContext?.hasToSubscribeToFreeEvent) {
    return (
      <SubscriptionCta
        source={source}
        setShowSubscriptionPopup={setShowSubscriptionPopup}
        selectedEventId={selectedEventId}
        selectedAlbum={selectedAlbum}
      />
    );
  }

  // Default: Render upload CTA for normal upload flow
  return (
    <GroupedUploaderActions
      source={source}
      selectedAlbum={selectedAlbum}
      selectedEventId={selectedEventId}
      showUploaderOption={showUploaderOption}
      setShowUploaderOption={setShowUploaderOption}
    />
  );
};

export default UploadActions;
